import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { getAllPendingTables } from "../Redux/Actions/pendingTableActions";
import "./KitchenOrder.css";

function BeverageOrder() {
  const [orders, setOrders] = useState([]);
  const [orderCounter, setOrderCounter] = useState(1);
  const [products, setProducts] = useState([]);
  const [readyOrders, setReadyOrders] = useState([]);

  const dispatch = useDispatch();
  const pendingTables = useSelector((state) => state.pendingTableReducer.pendingTables);

  useEffect(() => {
    dispatch(getAllPendingTables());
  }, [dispatch]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("/api/Product/getAllProducts");
        setProducts(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des produits :", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get("/api/Bills/getAllBills");
        const paidOrders = response.data
          .filter((bill) => bill.status === "paid")
          .map((bill, index) => ({
            orderId: bill._id,
            orderNumber: orderCounter + index,
            tableNumber: bill.tableNumber,
            confirmationDate: new Date(bill.date),
            items: bill.items,
            status: "paid",
          }));

        const pendingOrders = Object.values(pendingTables).map((table, index) => ({
          orderId: table.tableNumber,
          orderNumber: orderCounter + paidOrders.length + index,
          tableNumber: table.tableNumber,
          confirmationDate: new Date(table.createdAt),
          items: table.items,
          status: "pending",
        }));

        setOrders([...paidOrders, ...pendingOrders]);
        setOrderCounter((prev) => prev + paidOrders.length + pendingOrders.length);
      } catch (error) {
        console.error("Erreur lors du chargement des commandes :", error);
      }
    };

    fetchOrders();
  }, [pendingTables]);

  useEffect(() => {
    const fetchReadyOrders = async () => {
      try {
        const response = await axios.get("/api/ReadyOrders/getAllReadyOrders");
        setReadyOrders(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des commandes prêtes :", error);
      }
    };

    fetchReadyOrders();
  }, []);

  const getCategory = (subProductId) => {
    const product = products.find((prod) =>
      prod.subProducts.some((sub) => sub._id?.toString() === subProductId?.toString())
    );
    return product ? product.category : "Non catégorisé";
  };

  const getProductName = (subProductId) => {
    const product = products.find((prod) =>
      prod.subProducts.some((sub) => sub._id?.toString() === subProductId?.toString())
    );
    return product ? product.name : "Produit inconnu";
  };

  const handleOrderReady = async (order) => {
    try {
      const newOrder = {
        ...order,
        readyTime: new Date(),
        confirmationDate: new Date(order.confirmationDate),
        isReady: true,
      };

      await axios.post("/api/ReadyOrders/addReadyOrder", newOrder);

      setOrders((prev) => prev.filter((o) => o.orderId !== order.orderId));
      setReadyOrders((prev) => [...prev, newOrder]);

      alert("Commande marquée comme prête !");
    } catch (error) {
      console.error("Erreur lors de la mise en prêt de la commande :", error);
    }
  };

  const filteredOrders = orders.filter((order) =>
    order.items.some((item) => getCategory(item.id) === "BEVERAGES")
  );

  return (
    <div className="kitchen-order-container">
      <h2>Ordres Comptoir</h2>
      <table className="order-table">
        <thead>
          <tr>
            <th>Numéro de commande</th>
            <th>Numéro de table</th>
            <th>Date de confirmation</th>
            <th>Nature de la commande</th>
            <th>Catégorie</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders.map((order) => (
            <tr key={order.orderId}>
              <td>{order.orderNumber}</td>
              <td>{order.tableNumber}</td>
              <td>{order.confirmationDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</td>
              <td>
                <ul>
                  {order.items.map((item, idx) => (
                    <li key={`${order.orderId}-${idx}`}>
                      {getProductName(item.id)} - {item.name} x {item.quantity}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul>
                  {order.items.map((item, idx) => (
                    <li key={`${order.orderId}-cat-${idx}`}>{getCategory(item.id)}</li>
                  ))}
                </ul>
              </td>
              <td>
                <button onClick={() => handleOrderReady(order)}>Prêt</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BeverageOrder;
